module.exports = __webpack_public_path__ + "img/59.8a863d91.png";